import { PromoDevelopers } from 'src/components/ProductDetailed/PromoDevelopers';

export type ContainersInstructionBannerData = {
  id?: string;
  variant: 'ContainersInstruction';
  link?: string;
};

export function ContainersInstruction(props: ContainersInstructionBannerData) {
  const { id, link } = props;

  return <PromoDevelopers id={id} link={link} />;
}
